<script setup lang="ts">

const getLink = (platform: string) => {
  const currentUrl = encodeURIComponent(window.location.href);
  const pageTitle = encodeURIComponent(document.title);
  switch (platform) {
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;
    case 'twitter':
      return `https://twitter.com/intent/tweet?url=${currentUrl}&text=${pageTitle}`;
    case 'whatsapp':
      return `https://wa.me/?text=${pageTitle}%20${currentUrl}`;
    case 'instagram':
      return `https://www.instagram.com/`;
    case 'linkedin':
      return `https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`;
    case 'telegram':
      return `https://t.me/share/url?url=${currentUrl}&text=${pageTitle}`;
    default:
      return '';
  }
}

const copyToClipboard = () => {
  const url = window.location.href;
  navigator.clipboard.writeText(url).then(() => {
    alert('Link copiado para a área de transferência!');
  }).catch(err => {
    console.error('Falha ao copiar: ', err);
    // Fallback para navegadores mais antigos
    const textarea = document.createElement('textarea');
    textarea.value = url;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  });
}
</script>
<template>
  <span>
    <client-only>
      <div class="dropdown d-inline-block" data-bs-toggle="tooltip" title="Compartilhar">
        <button class="btn btn-icon btn-light-primary btn-xs shadow-sm rounded-circle ms-2 mb-2" type="button"
                data-bs-toggle="dropdown">
          <i class="fi-share"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end my-1">
          <a class="dropdown-item" type="button" target="_blank" :href="getLink('facebook')">
            <i class="fi-facebook fs-base opacity-75 me-2"></i>Facebook
          </a>
          <a class="dropdown-item" type="button" target="_blank" :href="getLink('linkedin')">
            <i class="fi-linkedin fs-base opacity-75 me-2"></i>LinkedIn
          </a>
          <a class="dropdown-item" type="button" target="_blank" :href="getLink('telegram')">
            <i class="fi-telegram fs-base opacity-75 me-2"></i>Telegram
          </a>
          <a class="dropdown-item" type="button" target="_blank" :href="getLink('instagram')">
            <i class="fi-instagram fs-base opacity-75 me-2"></i>Instagram
          </a>
          <a class="dropdown-item" type="button" target="_blank" :href="getLink('whatsapp')">
            <i class="fi-whatsapp fs-base opacity-75 me-2"></i>Whatsapp
          </a>
          <a class="dropdown-item" type="button" target="_blank" :href="getLink('twitter')">
            <Icon icon="pajamas:twitter" class="fs-base opacity-75 me-2"/>
            X/Twitter
          </a>
          <button class="dropdown-item" type="button" @click="copyToClipboard">
            <Icon icon="tabler:copy" class="fs-base opacity-75 me-2"/>
            Copiar
          </button>
        </div>
      </div>
    </client-only>
  </span>
</template>
